import {Theme, createStyles} from '@material-ui/core';

export type HeaderBarClassList =
	| 'header'
	| 'toolbar'
	| 'logoWrapper'
	| 'logo'
	| 'name'
	| 'link'
	| 'linkMobile'
	| 'logoAndLanguage'
	| 'linksMobileWrapper'
	| 'linksMobileBottom'
	| 'closeMenuButton'
	| 'rightSide'
	| 'drawerPaper'
	| 'emailLink'
	| 'menuButton';

export const headerBarStyles = (theme: Theme) =>
	createStyles<HeaderBarClassList, {}>({
		header: {
			'& svg-icon__aporia': {
				color: 'inherit',
				fill: 'currentColor',
			},
			'&.-with-offset': {
				marginBottom: -92,
				color: theme.palette.common.white,
			},
		},
		toolbar: {
			display: 'flex',
			justifyContent: 'space-between',
		},
		logoWrapper: {
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			textDecoration: 'none',
		},
		logoAndLanguage: {
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			textDecoration: 'none',
			color: theme.palette.text.primary,

			[theme.breakpoints.down('xs')]: {
				width: '100%',
				justifyContent: 'space-between',
			},
		},
		logo: {
			marginTop: theme.spacing(3),
			marginBottom: theme.spacing(3),
			marginRight: theme.spacing(2),
			[theme.breakpoints.down('sm')]: {
				marginTop: theme.spacing(1.5),
				marginBottom: theme.spacing(1.5),
			},
		},
		name: {
			marginRight: theme.spacing(5),
			color: theme.palette.primary.light,
			fill: theme.palette.primary.light,
			[theme.breakpoints.down('sm')]: {
				display: 'none',
			},
		},
		link: {
			transition: 'color',
			fontFamily: 'GolosTextWebBlack',
			transitionDuration: `${theme.transitions.duration.standard}ms`,
			paddingLeft: theme.spacing(3),
			paddingRight: theme.spacing(3),
			fontSize: theme.typography.pxToRem(18),
			lineHeight: theme.typography.pxToRem(18),
			letterSpacing: '0.12rem',
			'&:hover': {
				textDecoration: 'none',
				color: theme.palette.primary.light,
			},
			'&:active': {
				textDecoration: 'none',
				color: theme.palette.primary.dark,
			},
			'&:last-child': {
				paddingRight: 0,
			},
			[theme.breakpoints.down('sm')]: {
				fontFamily: 'UbuntuRegular',
				fontSize: theme.typography.pxToRem(14),
			},
		},
		linkMobile: {
			width: '100%',
			padding: theme.spacing(1.5),
			color: theme.palette.common.white,
			fontFamily: 'GolosTextWebBlack',
			textAlign: 'center',
			letterSpacing: '0.12rem',
			fontSize: theme.typography.pxToRem(20),
			lineHeight: theme.typography.pxToRem(20),
		},
		linksMobileWrapper: {
			display: 'flex',
			justifyContent: 'center',
			flexDirection: 'column',
		},
		linksMobileBottom: {
			display: 'flex',
			justifyContent: 'center',
			flexDirection: 'row',
			alignItems: 'center',
			paddingBottom: theme.spacing(5),
			paddingTop: theme.spacing(2),
			'& .svg-icon': {
				'& [fill="#E8E5F0"]': {
					fill: theme.palette.primary.light,
				},
				'& [fill="#C8C4D8"]': {
					fill: theme.palette.primary.dark,
				},
			},
			'& .MuiLink-root:first-child': {
				marginRight: theme.spacing(2),
			},
		},
		menuButton: {
			marginRight: theme.spacing(-1.5),
		},
		closeMenuButton: {
			color: theme.palette.common.white,
		},
		rightSide: {
			display: 'flex',
			alignItems: 'center',

			'.MuiAppBar-colorPrimary &, .-with-offset &, &.-is-in-menu': {
				color: theme.palette.common.white,
			},
		},
		drawerPaper: {
			padding: theme.spacing(0, 2.5),
			backgroundColor: theme.palette.primary.main,
			width: '100vw',
			minHeight: '60vh',
			display: 'flex',
			justifyContent: 'space-between',
		},
		emailLink: {
			color: theme.palette.common.white,
			textDecoration: 'underline',
			fontSize: theme.typography.pxToRem(18),
			lineHeight: theme.typography.pxToRem(22),
			width: '100%',
			textAlign: 'center',
		},
	});
